import clsx from 'clsx';
import React, { memo, ReactNode } from 'react';

type Props = {
    size?: 'sm' | 'md';
    kind?: 'primary' | 'secondary';
    disabled?: boolean;
    title?: ReactNode;
    valueActive?: ReactNode;
    valueInactive?: ReactNode;
    active: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
};

export const Switch = memo(({
    active,
    onChange,
    size = 'md',
    kind = 'primary',
    disabled = false,
    title,
    valueActive,
    valueInactive,
}: Props) => (
    <div className="vss-switch">
        {title && (
            <div className={clsx({
                'vss-switch__title': true,
                'vss-switch__title--disabled': disabled,
            })}
            >{title}
            </div>
        )}

        <div className="vss-switch__contents">
            <label
                className={clsx({
                    'vss-switch__label': true,
                    'vss-switch__label--sm': size === 'sm',
                })}
            >

                <input
                    checked={active}
                    onChange={onChange}
                    className={clsx({
                        'vss-switch__input': true,
                        'vss-switch__input--secondary': kind === 'secondary',
                    })}
                    type="checkbox"
                    disabled={disabled}
                />

                <span className={clsx({
                    'vss-switch__slider': true,
                    'vss-switch__slider--sm': size === 'sm',
                    'vss-switch__slider--disabled': disabled,
                })}
                />
            </label>

            {valueActive && valueInactive && (
                <div className="vss-switch__value">
                    {active ? valueActive : valueInactive}
                </div>
            )}
        </div>
    </div>
));
